import React from 'react';
import { Box, Button, Typography, Tabs, Tab, Paper, styled, AppBar, Toolbar, useScrollTrigger, Link, useMediaQuery, IconButton, Menu, MenuItem, MenuList, List, ListItem, ListItemIcon, ListItemText, Drawer, Divider } from '@mui/material';
import EastIcon from '@mui/icons-material/East';
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import logo from '../assests/rplogo2.png';
import { Home, HomeMax, HomeRepairService, HomeWorkOutlined, MenuBook, MonetizationOnOutlined, OtherHouses, OtherHousesOutlined, Phone, PhoneCallbackOutlined, PhoneOutlined, Sell } from '@mui/icons-material';
import { Link as RouterLink } from 'react-router-dom';
import MenuIcon from '@mui/icons-material/Menu';

function ElevationScroll({ children }) {
    const trigger = useScrollTrigger({
        disableHysteresis: true,
        threshold: 0,
    });

    return React.cloneElement(children, {
        elevation: trigger ? 4 : 0,
        style: {
            backgroundColor: trigger ? 'white' : 'transparent',
            transition: 'background-color 0.3s ease-out',
        },
    });
}
const CustomBanner = styled(Paper)(({ theme }) => ({
    background: ` linear-gradient(
        rgb(197 192 192 / 7%), 
        rgb(0 0 0 / 28%)
      ),url(${logo})`,
    backgroundSize: 'cover',
    backgroundRepeat: 'norepeat',
    backgroundPosition: 'center',
    overflow: 'hidden',
    // padding: 40,
    display: 'flex',
    justifyContent: 'center',
    width: '60px',
    alignItems: 'start',
    height: '60px',
    borderRadius: 0,
}))

const StyledTabs = styled(Tabs)(({ theme }) => ({
    height: 'auto',
    background: 'inherit',
    ml: '2em',
    '& .Mui-selected': {
        background: 'inherit',
        color: '#000'
    }
}))

const StyledTab = styled(Tab)(({ theme }) => ({
    fontSize: '15px',
    color: '#000',
    textTransform: "none",
    width: '120px',
}))

const StyledTab1 = styled(Tab)(({ theme }) => ({
    fontSize: '15px',
    color: '#000',
    textTransform: "none",
    width: '140px',
}))
const Mobtabs = styled(Tab)(({ theme }) => ({
    fontSize: '14px',
    color: '#000',
    textTransform: "none",
    width: 'auto',
    minHeight: '50px'
}))
const StyledBtn = styled(Button)(({ theme }) => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    color: '#fff',
    background: 'linear-gradient(to right, #2f57ef, #b966e7)',
    borderRadius: '80px',
    fontSize: '14.5px',
    padding: '7px 8px',
    fontWeight: 700,
    transition: '0.15s',
    textTransform: "none",
    width: '100%',
    maxWidth: '220px',
    minWidth: '190px',
    marginBottom: '0',
    marginRight: 'auto',
    '&:hover': {
        background: 'linear-gradient(to right, #2f57ef, #b966e7)',
        color: '#fff',
    }
}))

const Navbar = () => {
    const history = useNavigate();
    const location = useLocation();
    const matches = useMediaQuery('(max-width:600px)');
    const [value, setValue] = React.useState(0);
    const [isDrawerOpen, setIsDrawerOpen] = React.useState(false);
    const isQuestionsPage = location.pathname === '/Questions';


    // if (window.location.pathname === "/" && value !== 0) {
    //     setValue(0)
    //   } else
    //     if (window.location.pathname === "/Buy" && value !== 1) {
    //       setValue(1)
    //     } else
    //       if (window.location.pathname === "/Sell" && value !== 2) {
    //         setValue(2)
    //       } else
    //         if (window.location.pathname === "/Contact-Us" && value !== 3) {
    //           setValue(3)
    //         }

    const handleChange = (event, newValue) => {
        setValue(newValue);
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };


    const toggleDrawer = (open) => (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }
        setIsDrawerOpen(open);
    };

    const list = (
        <Box
            sx={{
                width: 250,
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'start',
                alignItems: 'start',
                p: '1em 0em 1em 1em'
            }}
            role="presentation"
            onClick={toggleDrawer(false)}
            onKeyDown={toggleDrawer(false)}
        >
            <Divider sx={{ width: '100%' }} />
            <Mobtabs icon={<Home fontSize='small' />} iconPosition="start" label="Home" onClick={() => history(`/`)} disableRipple /><Divider sx={{ width: '100%' }} />
            <Mobtabs icon={<OtherHouses fontSize='small' />} iconPosition="start" label="Buy" onClick={() => history(`/Buy`)} disableRipple /><Divider sx={{ width: '100%' }} />
            <Mobtabs icon={<Sell fontSize='small' />} iconPosition="start" label="Sell" onClick={() => history(`/Sell`)} disableRipple /><Divider sx={{ width: '100%' }} />
            <Mobtabs icon={<Phone fontSize='small' />} iconPosition="start" label="Contact us" onClick={() => history(`/Contact-Us`)} disableRipple /><Divider sx={{ width: '100%' }} />
        </Box>
    );


    return (
        <Box display="flex" justifyContent="start" alignItems="center" sx={{ backgroundColor: 'transparent', height: '100%', width: '100%', m: '1em 14em' }}>
            <AppBar sx={{ backgroundColor: '#F4F3F2', boxShadow: 'none' }}>
                <Toolbar sx={{ pl: '10px', justifyContent: matches ? 'start' : 'center', alignItems: 'center', }} disableGutters>
                    <Box sx={{ display: 'flex', alignItems: 'satr', ml: '1em' }}>
                        {
                            matches ?
                                <>
                                    <IconButton
                                        edge="start"
                                        aria-label="menu"
                                        onClick={toggleDrawer(true)}
                                        sx={{ mr: 1, color: '#444444' }}
                                    >
                                        <MenuIcon fontSize="small" color="#444444" />
                                    </IconButton>
                                    <Link
                                        component={RouterLink}
                                        to="/"
                                        sx={{ textDecoration: 'none' }}
                                    >
                                        <Box
                                            component="img"
                                            sx={{
                                                height: 70, // Adjust the height as needed
                                                width: 90, // This will maintain the aspect ratio
                                                mt: 1,
                                                mb: 0,
                                                ml: 1,
                                                mr: 2
                                            }}
                                            alt="Logo"
                                            src={`${logo}`} // Replace with the path to your logo
                                            onClick={() => history(`/`)}
                                        />
                                    </Link>
                                </>
                                :
                                <StyledTabs
                                    value={value}
                                    onChange={handleChange}
                                    textColor="inherit"
                                    indicatorColor="none"
                                    aria-label="secondary tabs example" >
                                    <Link
                                        component={RouterLink}
                                        to="/"
                                        sx={{ textDecoration: 'none' }}
                                    >
                                        <Box
                                            component="img"
                                            sx={{
                                                height: 70, // Adjust the height as needed
                                                width: 90, // This will maintain the aspect ratio
                                                mt: 1,
                                                mb: 0,
                                                ml: 1,
                                                mr: 2
                                            }}
                                            alt="Logo"
                                            src={`${logo}`} // Replace with the path to your logo
                                            onClick={() => history(`/`)}
                                        />
                                    </Link>
                                    <StyledTab icon={<Home fontSize='small' />} iconPosition="start" label="Home" onClick={() => history(`/`)} disableRipple />
                                    <StyledTab icon={<OtherHouses fontSize='small' />} iconPosition="start" label="Buy" onClick={() => history(`/Buy`)} disableRipple />
                                    <StyledTab icon={<Sell fontSize='small' />} iconPosition="start" label="Sell" onClick={() => history(`/Sell`)} disableRipple />
                                    <StyledTab1 icon={<Phone fontSize='small' />} iconPosition="start" label="Contact us" onClick={() => history(`/Contact-Us`)} disableRipple />
                                </StyledTabs>

                        }

                    </Box>
                    <Box sx={{ ml: matches ? '2em' : '35em' }}>
                        {!isQuestionsPage && (
                            <Button variant="container" sx={{ textTransform: 'capitalize' }} endIcon={<EastIcon sx={{ pt: '0px' }} />} onClick={() => history(`/Questions`)}>
                                Get Started
                            </Button>
                        )}
                    </Box>
                </Toolbar>
            </AppBar>
            {
                matches ?
                    <Drawer
                        anchor="left"
                        open={isDrawerOpen}
                        onClose={toggleDrawer(false)}
                    >
                        <Link
                            component={RouterLink}
                            to="/"
                            sx={{ textDecoration: 'none' }}
                        >
                            <Box
                                component="img"
                                sx={{
                                    height: 70, // Adjust the height as needed
                                    width: 90, // This will maintain the aspect ratio
                                    mt: 1,
                                    mb: 0,
                                    ml: 1,
                                    mr: 2
                                }}
                                alt="Logo"
                                src={`${logo}`} // Replace with the path to your logo
                                onClick={() => history(`/`)}
                            />
                        </Link>
                        <StyledTabs
                            value={value}
                            onChange={handleChange}
                            textColor="inherit"
                            indicatorColor="none"
                            aria-label="secondary tabs example" >

                            {list}
                        </StyledTabs>
                    </Drawer> :
                    null
            }
        </Box>
    );
};

export default Navbar;